
<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ; height: 100%">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>

                <van-field
                        v-model="formData.name"
                        :rules="[{ required: true, message: 'CCA官网账号不能为空' }]"
                        label="CCA官网账号"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入CCA官网账号"
                />
                <van-field
                        v-model="formData.password"
                        :rules="[{ required: true, message: 'CCA官网密码不能为空' }]"
                        label="CCA官网密码"
                        type="password"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入CCA官网密码"
                />

                <van-field
                        readonly
                        clickable
                        name="area"
                        :value="formData.ncounty?formData.nprovince+'/'+formData.ncity+'/'+formData.ncounty:''"
                        input-align="right"
                        label="省市委员会"
                        placeholder="点击选择省市区"
                        @click="showNamekey = true"
                />
                <van-popup v-model="showNamekey" position="bottom">
                    <van-area
                            :area-list="namekeyList"
                            :value="formData.namekey"
                            @confirm="onNamekeyConfirm"
                            @cancel="showArea = false"
                    />
                </van-popup>

                <van-field
                        readonly
                        clickable
                        name="area"
                        :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
                        input-align="right"
                        label="地区选择"
                        placeholder="点击选择省市区"
                        @click="showArea = true"
                />
                <van-popup v-model="showArea" position="bottom">
                    <van-area
                            :area-list="areaList"
                            :value="formData.area"
                            @confirm="onAreaConfirm"
                            @cancel="showArea = false"
                    />
                </van-popup>



            </van-cell-group>

            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交</van-button>
            </div>
        </van-form>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }


    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        margin-left: 10px;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import namekey from "../../../utils/namekey";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button,Calendar} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'CertDanweiBind',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                showDate:false,
                showArea:false,
                showNamekey:false,
                namekeyList:{},
                saveLoading:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                minDate: new Date((new Date()).valueOf()+3600*24*15*1000), //15天后
                formData: {
                    id: 0,
                    name:'',
                    password:'',
                    areas:'',
                    nprovince:'',
                    ncity:'',
                    ncounty:'',
                    province:'',
                    city:'',
                    county:'',
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.namekeyList = namekey;
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onNamekeyConfirm(values) {
                console.log(values);
                this.formData.namekey = values[2].code;
                this.formData.nprovince = values[0].name;
                this.formData.ncity = values[1].name;
                this.formData.ncounty = values[2].name;
                this.showNamekey = false;
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                    if (!this.formData.namekey) {
                        Toast('请选择委员会');
                        return
                    }
                }
                that.saveLoading = true;

                that.$api.post('/api/examecenter/bind', that.formData, (res) => {
                    that.saveLoading = false;
                    rbLink({
                        name:'QcxjStationResult',
                    },'replace')
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

        }
    }
</script>



// WEBPACK FOOTER //
// StationBind.vue?7d71021c